import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from '../../../plan/constants/event_names';

export class APFavoriteCourses {
  queries: Record<string, IQuery>;

  constructor(
    private ngAPFavoriteCoursesQuery: IQuery,
    private ngComponentCommunicatorService: CommunicatorService,
    private log: any
  ) {
    this.queries = {
      favoriteCourses: ngAPFavoriteCoursesQuery
    };
  }

  emphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
  }
  deEmphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
  }

  hasFavorites() {
    return !_4.isEmpty(this.ngAPFavoriteCoursesQuery.result.courses);
  }

  temporaryDragOperation_removeCourse(courseIndex: number) {
    this.queries.favoriteCourses.result.courses.splice(courseIndex, 1);
  }
}

angular.module('capability-ng-academic-planner').component('apFavoriteCourses', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/favorite/favorite.html',
  bindings: {},
  controller: APFavoriteCourses
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/favorite/favorite.ts